import { AxiosError } from "axios";
import { QueryKey, useQuery, UseQueryOptions } from "react-query";
import PartnersShowcaseService from "#/api/partnersShowcase/partnersShowcase";
import { errorTransform } from "#/infrastructure/error-handler";
import { RedeemPoints } from "#/api/partnersShowcase/types";

type GetRedeemPointsProps = {
  refreshTrigger?: number;
  options?: UseQueryOptions<RedeemPoints, AxiosError, RedeemPoints>;
  accountSource: string;
  cnpj?: string;
  cpf: string;
};

export const useGetRedeemPoints = ({
  refreshTrigger = 0,
  options = {},
  accountSource,
  cnpj,
  cpf,
}: GetRedeemPointsProps) => {
  return useQuery(
    ["points", cpf, cnpj, accountSource, refreshTrigger] as QueryKey,
    () => PartnersShowcaseService.getRedeemPoints(cpf, cnpj),
    {
      ...options,
      onError: (responseError: AxiosError) => {
        throw errorTransform(
          responseError,
          "Falha ao buscar pontos. Tente novamente."
        );
      },
    }
  );
};
